export default {
  // Set events timestamp
  eventsTimestamp(state) {
    state.eventsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  // Reset events timestamp
  eventsTimestampReset(state) {
    state.eventsTimestamp = null;
  },
  // Set events
  events(state, payload) {
    state.events = payload;
  },
};
